module.exports = __webpack_public_path__ + "static/media/Survey1PurposePrinciplesSelfInventory.abd3a6be.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video-champion-101/Survey1PurposePrinciplesSelfInventory.mp4
// module id = 7008
// module chunks = 2